// @flow
import * as React from 'react';

const AmpContext = React.createContext<boolean>(false);

export default AmpContext;
